<!-- CPP order flow: messages + input (header stays in parent ai-chatbot). -->
<div class="cpp-chat" *ngIf="cppConfig">
  <!-- Read-only pinned ship to location bar (stays fixed below the header). -->
  <div class="cpp-location-bar" *ngIf="pinnedLocationName" role="status" aria-label="Selected location">
    <img [src]="iconBase + '/location-pin-yellow.svg'" alt="" class="cpp-location-bar__icon" aria-hidden="true" />
    <span #pinnedLocation
          class="cpp-location-bar__name"
          [matTooltip]="pinnedLocationName"
          [matTooltipDisabled]="pinnedLocation.scrollWidth <= pinnedLocation.clientWidth">{{ pinnedLocationName }}</span>
  </div>

  <div class="cpp-chat-messages" #messagesContainer>
    <ng-container *ngFor="let message of messages">

      <!-- Welcome / simple AI text -->
      <div *ngIf="message.type === 'welcome' || message.type === 'ai-text'" class="cpp-message cpp-message--ai">
        <div class="cpp-message-row">
          <div class="cpp-message-avatar">
            <span class="cpp-ai-avatar"><img [src]="iconBase + '/agent.svg'" alt="AI" /></span>
          </div>
          <div class="cpp-message-bubble cpp-message-bubble--ai" [ngClass]="{ 'cpp-message-bubble--wide': message.orderHandoffMessage }">
            <p>{{ message.text }}</p>
          </div>
        </div>
        <span class="cpp-message-meta cpp-message-meta--ai">
          Evolve &middot; {{ message.timestamp | date:'shortTime' }}
        </span>

        <!-- Account selection for users with multiple accounts -->
        <div *ngIf="multiAccountSelection && message.accounts?.length" class="cpp-product-list">
          <input type="search"
                 class="cpp-account-search"
                 [(ngModel)]="message.accountSearch"
                 (ngModelChange)="filterAccounts(message, $event)"
                 [disabled]="isTyping || orderHandedOff || accountsLocked"
                 placeholder="Search an account..."
                 aria-label="Search an account" />
          <div class="cpp-account-list" role="group" aria-label="Locations" tabindex="0">
            <button *ngFor="let account of message.visibleAccounts"
                    type="button"
                    class="cpp-product-card cpp-product-card--clickable cpp-account-card"
                    [class.cpp-account-card--selected]="isAccountSelected(account)"
                    [disabled]="isTyping || orderHandedOff || accountsLocked"
                    [attr.aria-pressed]="isAccountSelected(account)"
                    (click)="toggleAccount(account)">
              <div class="cpp-product-card__body">
                <span #accountName class="cpp-product-card__name"
                    [matTooltip]="getAccountDisplayName(account)"
                    [matTooltipDisabled]="isTyping || orderHandedOff || accountsLocked || accountName.scrollWidth <= accountName.clientWidth">{{ getAccountDisplayName(account) }}</span>
                <span #accountAddress class="cpp-account-card__address"
                    [matTooltip]="account.address1 + ', ' + account.city + ', ' + account.state + ' - ' + account.zipCode"
                    [matTooltipDisabled]="isTyping || orderHandedOff || accountsLocked || accountAddress.scrollWidth <= accountAddress.clientWidth">{{ account.address1 }}, {{ account.city }}, {{ account.state }} - {{ account.zipCode }}</span>
              </div>
            </button>
          </div>

          <span *ngIf="!message.visibleAccounts.length" class="cpp-account-card__address" role="status">No accounts found.</span>
          <button *ngIf="message.showViewMoreAccounts && !accountsLocked && !orderHandedOff" class="cpp-view-more-btn" type="button" [disabled]="isTyping" (click)="viewMoreAccounts(message)">
            <img [src]="iconBase + '/eye.svg'" alt="" class="cpp-view-more-btn__icon" aria-hidden="true" />
            <span>View more results</span>
          </button>
        </div>
      </div>

      <!-- User message -->
      <div *ngIf="message.type === 'user'" class="cpp-message cpp-message--user">
        <div class="cpp-message-row">
          <div class="cpp-message-bubble cpp-message-bubble--user">
            <p>{{ message.text }}</p>
          </div>
          <div class="cpp-message-avatar cpp-message-avatar--user">
            <img [src]="iconBase + '/userBlack.svg'" alt="" />
          </div>
        </div>
        <span class="cpp-message-meta cpp-message-meta--user">
          {{ userDisplayName || 'You' }} &middot; {{ message.timestamp | date:'shortTime' }}
          <img *ngIf="message.readTickState"
               [src]="iconBase + '/double-ticks.svg'"
               alt="message-status"
               class="cpp-message-read-status"
               [ngClass]="{
              'cpp-message-read-status--grey': message.readTickState === 'grey',
              'cpp-message-read-status--yellow': message.readTickState === 'yellow'
            }" />
        </span>
      </div>

      <!-- No products found -->
      <div *ngIf="message.type === 'no-results'" class="cpp-message cpp-message--ai">
        <div class="cpp-message-row">
          <div class="cpp-message-avatar">
            <span class="cpp-ai-avatar"><img [src]="iconBase + '/agent.svg'" alt="AI" /></span>
          </div>
          <div class="cpp-message-bubble cpp-message-bubble--ai">
            <p *ngIf="message.text; else noResultsFallback">{{ message.text }}</p>
            <ng-template #noResultsFallback>
              <p>
                <ng-container *ngIf="message.searchTerm; else noSearchTerm">
                  Sorry, no products found matching <span class="cpp-text-highlight">&quot;{{ message.searchTerm }}&quot;</span>.
                </ng-container>
                <ng-template #noSearchTerm>Sorry, no products found.</ng-template>
                Please contact your local sales team for more information or search availability for another product.
              </p>
            </ng-template>
          </div>
        </div>
        <span class="cpp-message-meta cpp-message-meta--ai">
          {{virtualAssitant}} &middot; {{ message.timestamp | date:'shortTime' }}
        </span>
        <div class="cpp-action-panel" *ngIf="cartCount > 0">
          <div class="cpp-action-grid cpp-action-grid--primary cpp-action-grid--single">
            <button type="button" class="cpp-action-btn cpp-action-btn--primary cpp-action-btn--continue" [disabled]="isTyping || orderHandedOff" (click)="sendSelection('Continue to Order Details')">
              <img [src]="iconBase + '/checkmark.svg'" alt="" class="cpp-action-btn__icon" />
              <span>Continue to Order Details</span>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="message.type === 'exceptionMessage'" class="cpp-message cpp-message--ai">
        <div class="cpp-message-row">
          <div class="cpp-message-avatar">
            <span class="cpp-ai-avatar"><img [src]="iconBase + '/agent.svg'" alt="AI" /></span>
          </div>
          <div class="cpp-message-bubble cpp-message-bubble--ai">
            <p *ngIf="message.text; else noResultsFallback">{{ message.text }}</p>
            <ng-template #noResultsFallback>
              <p>
                <ng-container *ngIf="message.searchTerm">
                  <span>&quot;{{ message.searchTerm }}&quot;</span>.
                </ng-container>               
              </p>
            </ng-template>
          </div>
        </div>
        <span class="cpp-message-meta cpp-message-meta--ai">
          {{virtualAssitant}} &middot; {{ message.timestamp | date:'shortTime' }}
        </span>
        <div class="cpp-action-panel" *ngIf="cartCount > 0">
          <div class="cpp-action-grid cpp-action-grid--primary cpp-action-grid--single">
            <button type="button" class="cpp-action-btn cpp-action-btn--primary cpp-action-btn--continue" [disabled]="isTyping || orderHandedOff" (click)="sendSelection('Continue to Order Details')">
              <img [src]="iconBase + '/checkmark.svg'" alt="" class="cpp-action-btn__icon" />
              <span>Continue to Order Details</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Product search results (clickable) -->
      <div *ngIf="message.type === 'product-list'" class="cpp-message cpp-message--ai cpp-message--product-list">
        <div class="cpp-message-row">
          <div class="cpp-message-avatar">
            <span class="cpp-ai-avatar"><img [src]="iconBase + '/agent.svg'" alt="AI" /></span>
          </div>
          <div class="cpp-message-bubble cpp-message-bubble--ai">
            <p>
              I found <span class="cpp-text-highlight">{{ message.resultCount }} products</span>
              matching your request. You can add the product to cart from product list below or search availability for another product.
            </p>
          </div>
        </div>
        <span class="cpp-message-meta cpp-message-meta--ai">
          {{virtualAssitant}} &middot; {{ message.timestamp | date:'shortTime' }}
        </span>

        <div class="cpp-product-list">
          <div *ngFor="let product of message.visibleProducts; let i = index"
               class="cpp-product-card">
            <span class="cpp-product-card__index">{{ i + 1 }}</span>
            <div class="cpp-product-card__body">
              <span #productName class="cpp-product-card__name cpp-product-card__name--product"
                    [matTooltip]="product.itemDescription"
                    [matTooltipDisabled]="productName.scrollWidth <= productName.clientWidth">{{ product.itemDescription }}</span>

              <span #priceLine class="cpp-product-card__meta cpp-product-card__meta--price"
                    *ngIf="(isCPPPriceAccess && product.basePrice) || product.activeIngredients"
                    [matTooltip]="priceLine.innerText"
                    [matTooltipDisabled]="priceLine.scrollWidth <= priceLine.clientWidth">
                <span *ngIf="isCPPPriceAccess && product.basePrice" class="cpp-product-card__strong">{{ product.basePrice | currency:'USD':'symbol':'1.4-4' }}{{ product.pricingUOM ? '/' + product.pricingUOM : '' }}</span>
                <span *ngIf="isCPPPriceAccess && product.basePrice && product.activeIngredient" class="cpp-product-card__separator">&bull;</span>
                <ng-container *ngIf="product.activeIngredient">
                  AI: <span class="cpp-product-card__strong">{{ product.activeIngredient }}</span>
                </ng-container>
              </span>

              <span #detailLine class="cpp-product-card__meta"
                    *ngIf="product.marketingBrandDescription || product.packageSize || product.uom"
                    [matTooltip]="detailLine.innerText"
                    [matTooltipDisabled]="detailLine.scrollWidth <= detailLine.clientWidth">
                <ng-container *ngIf="product.marketingBrandDescription">{{ product.marketingBrandDescription }}</ng-container>
                <span *ngIf="product.marketingBrandDescription && product.packageSize" class="cpp-product-card__separator">&bull;</span>
                <ng-container *ngIf="product.packageSize">{{ product.packageSize }}</ng-container>
                <span *ngIf="(product.marketingBrandDescription || product.packageSize) && product.uom" class="cpp-product-card__separator">&bull;</span>
                <ng-container *ngIf="product.uom">({{ product.uom }})</ng-container>
              </span>

              <span #itemIdLine class="cpp-product-card__meta" *ngIf="product.itemNumber"
                    [matTooltip]="itemIdLine.innerText"
                    [matTooltipDisabled]="itemIdLine.scrollWidth <= itemIdLine.clientWidth">
                Item ID: {{ product.itemNumber }}
              </span>
            </div>
            <span *ngIf="product.InventoryTag"
                  class="cpp-inventory-badge"
                  [ngClass]="product.InventoryStopLightClass">{{ product.InventoryTag }}</span>
            <button type="button"
                    class="cpp-cart-btn"
                    [class.cpp-cart-btn--selected]="isInCart(product)"
                    [disabled]="isTyping || orderHandedOff"
                    [attr.aria-pressed]="isInCart(product)"
                    [attr.aria-label]="(isInCart(product) ? 'Remove ' : 'Add ') + product.itemDescription + (isInCart(product) ? ' from cart' : ' to cart')"
                    (click)="toggleCart(product, $event)">
              <img [src]="iconBase + (isInCart(product) ? '/cart-check-green.svg' : '/cart.svg')" alt="" class="cpp-cart-btn__icon" />
            </button>
          </div>

          <button *ngIf="message.showViewMore" class="cpp-view-more-btn" type="button" (click)="viewMore(message)">
            <img [src]="iconBase + '/eye.svg'" alt="" class="cpp-view-more-btn__icon" aria-hidden="true" />
            <span>View more results</span>
          </button>
        </div>
      </div>

      <!-- Minimal cart summary with action links (count stays live) -->
      <div *ngIf="message.type === 'cart-summary'" class="cpp-message cpp-message--ai cpp-message--wide">
        <div class="cpp-message-row">
          <div class="cpp-message-avatar">
            <span class="cpp-ai-avatar"><img [src]="iconBase + '/agent.svg'" alt="AI" /></span>
          </div>
          <div class="cpp-message-bubble cpp-message-bubble--ai">
            <p>
              <span class="cpp-text-highlight">{{ cartCount }}</span> item{{ cartCount === 1 ? '' : 's' }} in your cart.
            </p>
          </div>
        </div>
        <span class="cpp-message-meta cpp-message-meta--ai">
          {{virtualAssitant}} &middot; {{ message.timestamp | date:'shortTime' }}
        </span>
        <div class="cpp-action-panel">
          <div class="cpp-action-grid cpp-action-grid--primary cpp-action-grid--single">
            <button type="button" class="cpp-action-btn cpp-action-btn--primary cpp-action-btn--continue" [disabled]="isTyping || orderHandedOff" (click)="sendSelection('Continue to Order Details')">
              <img [src]="iconBase + '/checkmark.svg'" alt="" class="cpp-action-btn__icon" />
              <span>Continue to Order Details</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Confirmation prompt with Yes/No buttons -->
      <div *ngIf="message.type === 'confirmation-prompt'" class="cpp-message cpp-message--ai cpp-message--wide">
        <div class="cpp-message-row">
          <div class="cpp-message-avatar">
            <span class="cpp-ai-avatar"><img [src]="iconBase + '/agent.svg'" alt="AI" /></span>
          </div>
          <div class="cpp-message-bubble cpp-message-bubble--ai">
            <p>{{ message.text }}</p>
          </div>
        </div>
        <div class="cpp-action-panel">
          <div class="cpp-action-grid cpp-action-grid--primary">
            <button type="button"
                    class="cpp-action-btn cpp-action-btn--primary"
                    (click)="sendSelection('confirm-' + message.confirmAction.replace('confirm-', ''))">
              <img [src]="iconBase + '/checkmark.svg'" alt="" class="cpp-action-btn__icon" />
              <span>Yes</span>
            </button>
            <button type="button"
                    class="cpp-action-btn cpp-action-btn--primary"
                    (click)="sendSelection('cancel-' + message.confirmAction.replace('confirm-', ''), message)">
              <img [src]="iconBase + '/close-yellow.svg'" alt="" class="cpp-action-btn__icon" />
              <span>No</span>
            </button>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- Typing indicator -->
    <div *ngIf="isTyping" class="cpp-message cpp-message--ai cpp-message--processing">
      <div class="cpp-message-row">
        <div class="cpp-message-avatar">
          <span class="cpp-ai-avatar"><img [src]="iconBase + '/agent.svg'" alt="AI" /></span>
        </div>
        <div class="cpp-message-bubble cpp-message-bubble--ai cpp-message-bubble--processing">
          <div class="cpp-typing-dots"><span></span><span></span><span></span></div>
          <p>{{ cppConfig.processingMessage }}</p>
        </div>
      </div>
      <span class="cpp-message-meta cpp-message-meta--ai">
        {{virtualAssitant}} &middot; {{ processingTimestamp | date:'shortTime' }}
      </span>
    </div>
  </div>

  <div class="chat-input-container">
    <button
      type="button"
      class="cpp-home-btn"
      matTooltip="Reset Conversation"
      [matTooltipPosition]="'above'"
      aria-label="Reset Conversation"
      [disabled]="isConfirmPromptPending"
      (click)="sendSelection('go to home')">
      <img [src]="iconBase + '/home.svg'" alt="" class="cpp-home-btn__icon" aria-hidden="true" />
    </button>
    <div class="chat-input-wrap">
      <input
        type="text"
        class="chat-input"
        [(ngModel)]="userInput"
        (keypress)="onKeyPress($event)"
        [placeholder]="inputPlaceholder"
        [disabled]="isTyping || isAccountSelectionPending || orderHandedOff" />
      <button class="send-btn" type="button" (click)="sendMessage()" [disabled]="isTyping || isAccountSelectionPending || orderHandedOff || !userInput.trim()">
        <img [src]="iconBase + '/prompt.svg'" alt="Send" class="send-icon" />
      </button>
    </div>
  </div>
</div>
